module.exports = __webpack_public_path__ + "img/4-5.f1847c27.svg";